import { render } from "./UserJourney.vue?vue&type=template&id=3fd69d4e"
import script from "./UserJourney.vue?vue&type=script&lang=js"
export * from "./UserJourney.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/digiasia.asia.bak/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__